// Section 22 Settings (an overlay root): theme (light, dark, high contrast), text size, reduced
// motion, autosave count and the confirm-end-season toggle, persisted under `utopia:settings`.
import { AUTOSAVE_MAX, AUTOSAVE_MIN, closeOverlay, setSettings, settings, type Motion, type TextSize, type Theme } from '../../store';
import { uiText } from '../text/en';
import './settings.css';

const THEMES: Theme[] = ['system', 'light', 'dark', 'high-contrast'];
const SIZES: TextSize[] = ['small', 'normal', 'large'];
const MOTIONS: Motion[] = ['system', 'reduce', 'full'];

function Radios<T extends string>(props: {
  name: string;
  legend: string;
  values: readonly T[];
  labels: Record<string, string>;
  value: T;
  onChange: (v: T) => void;
}) {
  return (
    <fieldset class="settings__group">
      <legend>{props.legend}</legend>
      {props.values.map((v) => (
        <label key={v} class="field--check">
          <input
            type="radio"
            name={props.name}
            value={v}
            checked={props.value === v}
            onChange={() => props.onChange(v)}
          />
          <span>{props.labels[v] ?? v}</span>
        </label>
      ))}
    </fieldset>
  );
}

export function SettingsPanel() {
  const s = settings.value;
  const t = uiText.settings;
  return (
    <div class="settings">
      <header class="overlay__head">
        <h2 id="settings-title">{t.title}</h2>
        <button type="button" class="button button--small" onClick={() => closeOverlay()}>
          {t.close}
        </button>
      </header>
      <Radios name="theme" legend={t.theme} values={THEMES} labels={t.themes} value={s.theme} onChange={(theme) => setSettings({ theme })} />
      <Radios
        name="text-size"
        legend={t.textSize}
        values={SIZES}
        labels={t.textSizes}
        value={s.textSize}
        onChange={(textSize) => setSettings({ textSize })}
      />
      <Radios name="motion" legend={t.motion} values={MOTIONS} labels={t.motions} value={s.motion} onChange={(motion) => setSettings({ motion })} />
      <label class="field">
        <span class="field__label">
          {t.autosaves} <span class="num">{s.autosaveCount}</span>
        </span>
        <input
          type="range"
          min={AUTOSAVE_MIN}
          max={AUTOSAVE_MAX}
          value={s.autosaveCount}
          onInput={(e) => setSettings({ autosaveCount: Number(e.currentTarget.value) })}
        />
        <span class="hint">{t.autosavesHint}</span>
      </label>
      <label class="field--check settings__check">
        <input
          type="checkbox"
          checked={s.confirmEndSeason}
          onChange={(e) => setSettings({ confirmEndSeason: e.currentTarget.checked })}
        />
        <span>{t.confirmEnd}</span>
      </label>
    </div>
  );
}
